import { render, staticRenderFns } from "./RenderCargaDanfe.vue?vue&type=template&id=5456384a&"
import script from "./RenderCargaDanfe.vue?vue&type=script&lang=ts&"
export * from "./RenderCargaDanfe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports